import React, {Component} from 'react'
import {
  getComponentDisplayName,
  curry,
  PLACEHOLDER as _,
  filteredParamsFromLocation,
  pushQuery,
  pushParam,
} from '../utils'
import {getLocation, history} from 'utils/history'

const pushQueryTracked = curry(pushQuery)
const pushParamTracked = curry(pushParam)

/**
 * Higher order component for Fetching and determining price based on geographical location.
 * @param {Object} options - Initial config options.
 * @param {String} options.expose - Name of the prop object that contains price data & methods.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */

export default ({expose = 'search', trackParams = [], exposeParams = []} = {}) => (Wrapped) => {
  class SearchParams extends Component {
    constructor(props) {
      super(props)
      this.update = true
      this.state = {
        searchParams: filteredParamsFromLocation(getLocation(), exposeParams),
      }
    }
    
    componentWillMount() {
      this.hashHistoryListener = history.listen((location) => {
        if (location.breakLoop) this.update = false
        this.setState({searchParams: filteredParamsFromLocation(location, exposeParams)}, () => {
          this.update = true
        })
      })
    }
    
    componentWillUnmount() {
      this.hashHistoryListener()
    }
    
    shouldComponentUpdate() {
      return this.update // Only update component on url pop
    }
    
    render() {
      return (
        <Wrapped
          {...{
            ...this.props,
            [expose]: {
              query: this.state.searchParams,
              pushQuery: pushQueryTracked(_, trackParams, exposeParams),
              pushParam: pushParamTracked(_, trackParams, exposeParams),
              queryString: getLocation().search, // TO DO: Remove this it's not always up to date
            },
          }} />
      )
    }
  }
  
  SearchParams.displayName = `SearchParams(${getComponentDisplayName(Wrapped)})`
  
  return SearchParams
}



// WEBPACK FOOTER //
// ./src/higher-order-components/search-params.jsx